import { ExpandLess, ExpandMore, FactCheckOutlined } from '@mui/icons-material';
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import MenuItem from 'app/shared/layout/menus/menu-item';
import React from 'react';
import { Translate } from 'react-jhipster';

export interface IReportsMenu {
  index: number;
  onExpand: (index: number) => void;
  isExpanded: boolean;
  setOpen: (value: boolean) => void;
  drawerIsOpen: boolean;
}

export const ReportsMenu = ({ onExpand, isExpanded, index, drawerIsOpen, setOpen }: IReportsMenu) => {
  const initialTheme = localStorage.getItem('USER_THEME') as 'light' | 'dark' | null;

  return (
    <>
      <Tooltip title={drawerIsOpen ? '' : <Translate contentKey="global.menu.reports">Relatórios</Translate>} placement="right">
        <ListItemButton
          onClick={() => onExpand(index)}
          sx={{
            pl: { xs: '18px', md: '32px' },
            backgroundImage: isExpanded
              ? initialTheme === 'dark'
                ? 'linear-gradient(rgba(6, 13, 31, 0.9), rgba(6, 13, 31, 0.9))'
                : 'linear-gradient(rgb(226,226,226), rgb(226,226,226))'
              : 'none',
          }}
        >
          <ListItemIcon>
            <FactCheckOutlined />
          </ListItemIcon>
          <ListItemText
            primary={<Translate contentKey="global.menu.reports">Relatórios</Translate>}
            primaryTypographyProps={{
              fontFamily: 'Public Sans',
              fontWeight: isExpanded ? '600' : '400',
              fontSize: '14px',
            }}
            sx={{ opacity: drawerIsOpen ? 1 : 0 }}
          />
          {isExpanded ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
      </Tooltip>

      <Collapse in={isExpanded} timeout="auto" unmountOnExit>
        <List component="div" disablePadding onClick={() => setOpen(false)}>
          <MenuItem icon="caret-right" to="/reports/alerts">
            <Translate contentKey="global.menu.reportTypes.alerts">Alertas</Translate>
          </MenuItem>
          <MenuItem icon="caret-right" to="/reports/daily">
            <Translate contentKey="global.menu.reportTypes.daily">Diário</Translate>
          </MenuItem>
          <MenuItem icon="caret-right" to="/reports/journey">
            <Translate contentKey="global.menu.reportTypes.journey">Jornada</Translate>
          </MenuItem>
          <MenuItem icon="caret-right" to="/reports/passages">
            <Translate contentKey="global.menu.reportTypes.passages">Passagens por cerca</Translate>
          </MenuItem>
        </List>
      </Collapse>
    </>
  );
};
